import React from 'react'
import { ReactComponent as Check } from '../../../icons/pageTick.svg'
import { CheckBoxSquare } from './checkBoxElements'

export const CheckBoxStyled = ({ active, error }) => {
  return <div>{active ? <Check /> : <CheckBoxSquare error={error} />}</div>
}
